import { caution, success } from '../../../resources/styles';

const workflowStateButtonMap = {
    complete:{
        border: '1px solid rgba(0, 178, 138, 0.5)',
        ...success
    },
    in_progress:{
        border:'1px solid rgba(223,150,65,0.5)',
        ...caution
    }
}

export var getWorkFlowStyle = (state) => {
    if(state === 'complete')return workflowStateButtonMap.complete
    return workflowStateButtonMap.in_progress
}